import apiNotice from '@/model/login'

const state = {
  notice: [],
  notice_num: 0
}

const getters = {
  top_notice: (state) => state.notice.filter((item) => !item.status),
  notice: (state) => state.notice,
  notice_num: (state) => state.notice_num
}

const mutations = {
  setNoticeList(state, { data }) {
    state.notice = data
  },
  setNoticeNum(state, data) {
    state.notice_num = data
  }
}

const actions = {
  // 获取消息数量
  getNoticeNum({ commit }, data) {
    return new Promise((resolve) => {
      apiNotice
        .notifyNum(data)
        .then((res) => {
          commit('setNoticeNum', res.activity + res.system)
          resolve(res)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  },

  // 获取消息列表
  getNoticeList({ commit }, data) {
    return new Promise((resolve) => {
      apiNotice
        .getList(data)
        .then((res) => {
          // console.log('消息列表', res)
          commit('setNoticeList', res)
          resolve(res)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  },

  // 消息通知删除
  // eslint-disable-next-line
  delete({ commit }, data) {
    return new Promise((resolve) => {
      apiNotice
        .deleteNotice(data)
        .then((res) => {
          console.log('删除消息', data)
          resolve(res)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  },

  // 消息设为已读
  // eslint-disable-next-line
  setStatus({ commit }, data) {
    return new Promise((resolve) => {
      apiNotice
        .notifyRead(data)
        .then((res) => {
          console.log('消息已读', data)
          resolve(res)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
